export default "__VITE_ASSET__hmHQqIzB__"